import React from "react";
import Button from 'storybookComponents/Button';
import Field from "../multiTagField";
import Expansion from "components/Expansion";
import Icon from "storybookComponents/Icon";
import Typography from "storybookComponents/Typography";

const SentMessage = ({ classes }) => <div className={`${classes.flexBox} ${classes.rightPart}`}><Icon type=" icon-n-check" className={classes.sentSuccess} />&nbsp;<Typography type="body1">Sent successfully</Typography>&nbsp;</div>

const TestForm = ({ classes, expanded, smsEnabled, handleExpandedPanel, inviteScheduledAt, sendingTest, campaignTested, ...props }) => {
  return (
    <Expansion
      expanded={expanded === "Second"}
      name="Second"
      handleExpandedPanel={handleExpandedPanel}
      defaultOpen={!inviteScheduledAt}
      headerIcon={open => campaignTested && open ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null}
      header="Send Test Invite"
      subtitle={`Add your email(s) ${smsEnabled ? "and phone number(s) " : ""}below to test the event invites before publishing them`}
      rightSection={open =>
        campaignTested && !open ? <SentMessage classes={classes} /> : null
      }
    >
      <div>
        <Field {...props} keyName="emails" label="Email(s)" description="Enter emails separated by commas" />
        {
          smsEnabled ? <Field {...props} regex={/^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$/} mask="XXX-XXX-XXXX" restrictText keyName="phones" label="Phone Number(s)" description="Enter phone numbers separated by commas" /> : null
        }

        <Button className={classes.button} state={sendingTest || (!props.values.emails.length && !props.values.phones.length) ? "inactive" : "active"} onClick={props.handleSubmit} variant="primary" size="sm">Send Test Invite</Button>

      </div>
    </Expansion>
  )
}

export default TestForm;